export default __webpack_public_path__ + "static/media/English.e8d812f8.png";